import React, { createContext, useContext, useReducer, ReactNode } from "react";
import {
  MDSSessionContextValue,
  MDSSessionAction,
  MDSSessionArtifact,
} from "./mds-session-context.types";
import { mdsSessionReducer, createInitialState } from "./mds-session-context.reducer";
import { useEscapeKeyHandler } from "./mds-session-context.hooks";

const MDSSessionContext = createContext<MDSSessionContextValue | null>(null);

interface MDSSessionProviderProps {
  children: ReactNode;
}

export const MDSSessionProvider: React.FC<MDSSessionProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(mdsSessionReducer, createInitialState());

  const actions = {
    viewArtifact: ({ payload }: { payload: MDSSessionArtifact }) => {
      dispatch({
        type: MDSSessionAction.ViewArtifact,
        payload,
      });
    },

    closeArtifact: () => {
      dispatch({
        type: MDSSessionAction.CloseArtifact,
      });
    },
  };

  // Register escape key handler
  useEscapeKeyHandler(!!state.activeArtifact, actions.closeArtifact);

  const contextValue: MDSSessionContextValue = {
    state,
    actions,
  };

  return <MDSSessionContext.Provider value={contextValue}>{children}</MDSSessionContext.Provider>;
};

export const useMDSSession = (): MDSSessionContextValue => {
  const context = useContext(MDSSessionContext);

  if (!context) {
    throw new Error("useMDSSession must be used within a MDSSessionProvider");
  }

  return context;
};
